import { RulerSquareIcon } from './RulerSquareIcon';

/**
 * author: Michael Richins
 * id A94D1ED1-576F-4E2C-B165-ABAD797E8192
 * name ruler-square
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ruler-square.svg
 * tags
 * - Hardware / Tools 
 * - Drawing / Art 
 */
export const ArchitectureIcon = RulerSquareIcon;
export default ArchitectureIcon